(() => {
  if (window.__apolloGalleryControllerReady) return;
  window.__apolloGalleryControllerReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initGallery = root => {
    if (root.dataset.apolloGalleryReady === 'true') return;
    root.dataset.apolloGalleryReady = 'true';

    const viewport = root.querySelector('[data-apollo-gallery-viewport]');
    const slides = Array.from(root.querySelectorAll('[data-apollo-gallery-slide]'));
    const controls = root.querySelector('[data-apollo-gallery-controls]');
    const thumbs = root.querySelector('[data-apollo-gallery-thumbs]');
    const counter = root.querySelector('[data-apollo-gallery-counter]');
    if (!viewport || !slides.length) return;

    const visible = slides;
    let activeIndex = 0;
    let scrollFrame = null;

    const updateControls = () => {
      if (!visible.length) return;
      const current = Math.max(0, Math.min(visible.length - 1, activeIndex));
      if (counter) counter.textContent = `${current + 1} / ${visible.length}`;
      const previous = controls?.querySelector('[data-apollo-gallery-prev]');
      const next = controls?.querySelector('[data-apollo-gallery-next]');
      if (previous) previous.disabled = current === 0;
      if (next) next.disabled = current === visible.length - 1;
      thumbs?.querySelectorAll('[data-apollo-thumb-index]').forEach((button, index) => {
        button.classList.toggle('is-active', index === current);
        if (index === current) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    };

    const goTo = (index, smooth = true) => {
      if (!visible.length) return;
      activeIndex = Math.max(0, Math.min(visible.length - 1, index));
      const left = visible[activeIndex].offsetLeft - visible[0].offsetLeft;
      viewport.scrollTo({ left, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
      updateControls();
    };

    const buildThumbs = () => {
      if (!thumbs) return;
      thumbs.replaceChildren();
      thumbs.hidden = visible.length <= 1;
      visible.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'apollo-pdp-gallery__thumb';
        button.dataset.apolloThumbIndex = String(index);
        button.setAttribute('aria-controls', viewport.id);
        button.setAttribute('aria-label', (root.dataset.viewPhotoLabel || 'View photo [number]').replace('[number]', String(index + 1)));
        if (slide.dataset.mediaPreview) {
          const image = document.createElement('img');
          image.src = slide.dataset.mediaPreview;
          image.alt = '';
          image.width = 46;
          image.height = 58;
          image.loading = 'lazy';
          button.appendChild(image);
        } else {
          button.textContent = String(index + 1);
        }
        thumbs.appendChild(button);
      });
    };

    root.addEventListener('click', event => {
      if (event.target.closest('[data-apollo-gallery-prev]')) { goTo(activeIndex - 1); return; }
      if (event.target.closest('[data-apollo-gallery-next]')) { goTo(activeIndex + 1); return; }
      const thumb = event.target.closest('[data-apollo-thumb-index]');
      if (thumb) goTo(Number(thumb.dataset.apolloThumbIndex));
    });
    viewport.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = null;
        if (visible.length) {
          activeIndex = Math.max(0, Math.min(visible.length - 1, Math.round(viewport.scrollLeft / viewport.clientWidth)));
          updateControls();
        }
      });
    }, { passive: true });
    viewport.addEventListener('keydown', event => {
      if (event.target.closest('video, model-viewer, iframe')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : activeIndex + (event.key === 'ArrowRight' ? 1 : -1);
        goTo(index);
      }
    });
    if (controls) controls.hidden = visible.length <= 1;
    buildThumbs();
    updateControls();
  };

  const initAll = scope => {
    if (scope?.matches?.('[data-apollo-gallery]')) initGallery(scope);
    scope?.querySelectorAll?.('[data-apollo-gallery]').forEach(initGallery);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
